import { __assign, __extends } from "tslib";
import React, { useContext } from 'react';
import { isKeyArrowVertical, isKeyEnter, isKeySpace, someKeys } from '@skbkontur/react-ui/lib/events/keyboard/identifiers';
import { DropdownMenu } from '@skbkontur/react-ui/components/DropdownMenu';
import { TopBarButtonItem } from './TopBarButtonItem';
import { getAddonsTheme } from '../../lib/theming/ThemeHelpers';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { ThemeFactory } from '@skbkontur/react-ui/lib/theming/ThemeFactory';
import { jsStyles } from './TopBar.styles';
/**
 * Дропдаун в топбаре
 *
 * @visibleName TopBar.Dropdown
 */

var TopBarDropdown =
/** @class */
function (_super) {
  __extends(TopBarDropdown, _super);

  function TopBarDropdown() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dropdownMenu = null;

    _this.open = function () {
      if (_this.dropdownMenu) {
        _this.dropdownMenu.open();
      }
    };

    _this.close = function () {
      if (_this.dropdownMenu) {
        _this.dropdownMenu.close();
      }
    };

    _this.refDropdownMenu = function (ref) {
      return _this.dropdownMenu = ref;
    };

    _this.renderButton = function (captionProps) {
      var handleKeyDown = function handleKeyDown(event) {
        _this.handleKeyDown(event, captionProps.openMenu);
      };

      return React.createElement(ThemeContext.Provider, {
        value: ThemeFactory.create(_this.theme)
      }, React.createElement(TopBarButtonItem, {
        active: captionProps.opened,
        icon: _this.props.icon,
        minWidth: _this.props.minWidth ? _this.props.minWidth : undefined,
        tabIndex: 0,
        use: _this.props.use,
        onClick: captionProps.toggleMenu,
        onKeyDown: handleKeyDown
      }, _this.props.label));
    };

    _this.handleKeyDown = function (e, openMenu) {
      if (someKeys(isKeyEnter, isKeySpace, isKeyArrowVertical)(e)) {
        e.preventDefault();
        openMenu(true);
      }
    };

    return _this;
  }

  TopBarDropdown.prototype.render = function () {
    var _this = this;

    return React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this.theme = getAddonsTheme(theme);
      return React.createElement(ThemeContext.Provider, {
        value: ThemeFactory.create({
          menuItemHoverBg: _this.theme.tbMenuItemHoverBg,
          menuItemHoverColor: _this.theme.tbMenuItemHoverColor,
          menuItemPaddingX: _this.theme.tbMenuItemPaddingX
        }, _this.theme)
      }, React.createElement(DropdownMenu, __assign({}, _this.props, {
        ref: _this.refDropdownMenu,
        caption: _this.renderButton
      }), _this.props.children));
    });
  };

  TopBarDropdown.__KONTUR_REACT_UI__ = 'TopBarDropdown';
  TopBarDropdown.defaultProps = {
    use: 'default'
  };
  return TopBarDropdown;
}(React.Component);

export { TopBarDropdown };
export function TopBarDropdownMenuSeparator() {
  var theme = getAddonsTheme(useContext(ThemeContext));
  return React.createElement("div", {
    className: jsStyles.menuSeparator(theme)
  });
}
export function TopBarDropdownUserName(props) {
  var theme = getAddonsTheme(useContext(ThemeContext));
  return React.createElement("div", {
    className: jsStyles.userName(theme)
  }, props.userName);
}